import React from "react";
import { Visit } from "../../../system/AppState/AppVisitsState";
import { getVisitDuration, getVisitTypeText } from "../../AvailableVisitsAndTasksList";
import { VisitExtraHeader } from "./VisitExtraHeader";

export default function VisitBroadcastExtraHeader(props: {
  broadcast: Visit;
  onGoToVisit: () => void;
}) {
  const { broadcast } = props;

  return (
    <VisitExtraHeader
      patientInitials={broadcast.publicVisitBroadcastDetails.patientInitials}
      startTimeLocal={broadcast.publicVisitBroadcastDetails.startTimeLocal}
      endTimeLocal={broadcast.publicVisitBroadcastDetails.endTimeLocal}
      location={broadcast.publicVisitBroadcastDetails.location}
      price={broadcast.publicVisitBroadcastDetails.price}
      visitType={getVisitTypeText(broadcast.publicVisitBroadcastDetails.type)}
      visitDuration={getVisitDuration(broadcast)}
      onGoToVisit={props.onGoToVisit}
    />
  );
}
